module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "title": "Exames Vinculados no PCMSO"
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disabledConfigCell": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dab01ece"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/credenciada/consulta/_includes/pcmso.vue
// module id = 1589
// module chunks = 45